import {
  REGISTER_USER,
  REGISTER_USER_ERROR,
  LOGIN_USER,
  LOGIN_USER_ERROR,
  START_LOADING,
  STOP_LOADING,
  VERIFY_OTP_ERROR,
  VERIFY_OTP,
  GET_USER_WITH_FAVOURITE_COINS,
  POST_FAVOURITE_COIN,
  REGISTER_USER_WITH_GOOGLE,
  REGISTER_USER_WITH_GOOGLE_ERROR,
  LOGOUT_USER,
  GET_USER,
  SET_TOKEN,
  FETCH_WALLET_AMOUNT,
  EDIT_PROFILE,
  MODIFY_NAME_IN_VT,
  FETCH_BDETAILS,
  ADD_BDETAILS,
  WITHDRAW_MONEY,
  HANDLE_PAYMENT_ERROR,
  FETCH_PENDING_DETAILS,
  CLEAR_TRANSACTIONS,
  HIDE_SWAL,
  DELETE_BDETAILS,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD,
  CHANGE_CURRENT_PASSWORD,
} from "../types";

import { getToken } from "../../message";
import { toast } from "react-toastify";
const authReducer = (state, action) => {
  switch (action.type) {
    case REGISTER_USER:
      toast.success("Registration Successful!!", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      localStorage.setItem(
        "userDetailsforOTP",
        JSON.stringify({
          _id: action.payload.data._id,
          email: action.payload.data.email,
        })
      );

      return {
        ...state,
        userDetailsForOTP: {
          _id: action.payload.data._id,
          email: action.payload.data.email,
        },
        isAuthenticated: false,
        success: action.payload.success,
      };
    case REGISTER_USER_WITH_GOOGLE:
      return { ...state, userData: action.payload };
    case REGISTER_USER_ERROR:
    case REGISTER_USER_WITH_GOOGLE_ERROR:
      return { ...state, authError: action.payload };
    case LOGIN_USER:
      toast.success("Login Successful!!", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      localStorage.removeItem("userDetailsforOTP");
      localStorage.setItem("userData", JSON.stringify(action.payload.data));
      localStorage.setItem("token", JSON.stringify(action.payload.data.token));
      if (!localStorage.fcmToken) {
        getToken(
          action.payload.data.profile_data._id,
          action.payload.data.token
        );
      }
      // delete action.payload.data.walletData;
      return {
        ...state,
        userData: action.payload.data,
        message: action.payload.message,
        isAuthenticated: true,
        success: action.payload.success,
        userDetailsforOTP: null,
        token: action.payload.data.token,
      };
    case LOGIN_USER_ERROR:
      toast.error(action.payload, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return { ...state, authError: action.payload };
    case VERIFY_OTP:
      typeof action.payload.data !== "undefined" &&
      action.payload.data.profile_data
        ? localStorage.setItem("userData", JSON.stringify(action.payload.data))
        : console.log("not stored");
      action.payload.data.profile_data?.vrfy
        ? localStorage.removeItem("userDetailsforOTP")
        : console.log("not removed");
      if (
        typeof action.payload.data !== "undefined" &&
        action.payload.data.token
      ) {
        localStorage.setItem(
          "token",
          JSON.stringify(action.payload.data.token)
        );
      }
      if (
        !localStorage.fcmToken &&
        action.payload &&
        action.payload.data &&
        action.payload.data.profile_data
      ) {
        getToken(
          action.payload.data.profile_data._id,
          action.payload.data.token
        );
      }
      return {
        ...state,
        userData:
          typeof action.payload.data !== "undefined" && action.payload.data,
        token:
          typeof action.payload.data !== "undefined" &&
          action.payload.data.token,
        isAuthenticated: true,
      };
    case VERIFY_OTP_ERROR:
      action.payload &&
        action.payload.length > 0 &&
        toast.error(action.payload[0], {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      return { ...state, authError: action.payload };
    case START_LOADING:
      if (!action.Type) {
        action.Type = 1;
      }
      return {
        ...state,
        loading: action.Type !== 2,
        favouriteLoading: action.Type === 2,
        withdrawSwal: false,
      };
    case STOP_LOADING:
      return { ...state, loading: false, favouriteLoading: false };
    case LOGOUT_USER:
      localStorage.clear();
      return {
        ...state,
        userData: null,
        userDetailsForOTP: null,
        isAuthenticated: false,
        token: null,
        favouriteCoins: null,
      };
    case GET_USER:
      typeof action.payload.data !== "undefined" &&
        localStorage.setItem("userData", JSON.stringify(action.payload.data));
      if (typeof action.payload.data !== "undefined") {
      }
      if (!localStorage.fcmToken) {
        getToken(
          action.payload.data.profile_data._id,
          action.payload.data.token
        );
      }
      return {
        ...state,
        isAuthenticated: true,
        userData:
          typeof action.payload.data !== "undefined"
            ? action.payload.data
            : state.userData,
      };
    case POST_FAVOURITE_COIN:
      return {
        ...state,
        favouriteCoins:
          action.payload.data.profile_data.favourites.coin.length > 0
            ? action.payload.data.profile_data.favourites.coin.map((d) => d.id)
            : [],
      };
    case GET_USER_WITH_FAVOURITE_COINS:
      return {
        ...state,
        isAuthenticated: true,
        favouriteCoins:
          action.payload?.data?.profile_data?.favourites.coin.length > 0
            ? action.payload.data.profile_data.favourites.coin.map((d) => d.id)
            : [],
      };
    case SET_TOKEN:
      return { ...state, token: action.payload };
    case EDIT_PROFILE:
      toast.success("Profile Updated Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      let data = {
        ...state.userData,
        profile_data: {
          ...state.userData.profile_data,
          name: action.payload.data.name,
          avatar: action.payload.data.avatar,
          userName: action.payload.data.userName,
          mobile: action.payload.data.mobile,
        },
      };
      localStorage.setItem("userData", JSON.stringify(data));

      return { ...state, userData: data };
    case MODIFY_NAME_IN_VT:
      // let filteredPortfolio = state.userData.VirtualPortfolio.filter(
      //   (c) => action.payload.data.serno === c.serno
      // )[0];
      state.userData.VirtualPortfolio.map((c) =>
        action.payload.data.serno === c.serno ? action.payload.data : c
      );
      // console.log({ ...state,userData:{...state.userData,VirtualPortfolio:{...state.userData.VirtualPortfolio,...filteredPortfolio}} })
      toast.success("Edited Portfolio Name Successfully", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return {
        ...state,
        userData: {
          ...state.userData,
          VirtualPortfolio: state.userData.VirtualPortfolio.map((c) =>
            action.payload.data.serno === c.serno ? action.payload.data : c
          ),
        },
      };

    case FETCH_WALLET_AMOUNT:
      return {
        ...state,
        walletData:
          state.walletData?.transactions &&
          state.walletData.transactions.length > 0
            ? {
                ...state.walletData,
                hasTransactions:
                  state.walletData?.transactions &&
                  state.walletData.transactions.length > 0 &&
                  action.payload.data &&
                  action.payload.data.transactions &&
                  action.payload.data.transactions.length === 0
                    ? false
                    : true,
                transactions: [
                  ...state.walletData.transactions,
                  ...action.payload.data.transactions,
                ],
              }
            : { ...action.payload.data, hasTransactions: true },
      };
    case FETCH_BDETAILS:
      return { ...state, bDetails: action.payload };
    case ADD_BDETAILS:
      toast.success("Added details Successfully", { autoClose: 6000 });
      return { ...state, bDetails: action.payload };
    case WITHDRAW_MONEY:
      // toast.success("Withdrawn Successful", { autoClose: 6000 });
      return { ...state, withdrawSwal: true };
    case HIDE_SWAL:
      return { ...state, withdrawSwal: false };
    case HANDLE_PAYMENT_ERROR:
      return { ...state, paymentError: action.payload };
    case FETCH_PENDING_DETAILS:
      return { ...state, pendingDetails: action.payload };
    case CLEAR_TRANSACTIONS:
      return {
        ...state,
        walletData: { ...state.walletData, transactions: null },
      };
    case DELETE_BDETAILS:
      return { ...state };
    case CHANGE_PASSWORD_REQUEST:
      localStorage.setItem("idForPassword", action.payload.data._id);
      return { ...state };
    case CHANGE_PASSWORD:
      toast.success("Password changed Successfully", { autoClose: 6000 });
      return { ...state };
    case CHANGE_CURRENT_PASSWORD:
      toast.success("Changed password Successfully", { autoClose: 6000 });
      return { ...state };
    default:
      return { ...state };
  }
};

export default authReducer;
